import { createSlice } from '@reduxjs/toolkit';

/**
 * Redux slice for managing bulk candidate selection state
 */
const emergencySelectionSlice = createSlice({
  name: 'emergencySelection',
  initialState: {
    selectedIds: [],
    isSending: false,
    sendProgress: { sent: 0, total: 0 }
  },
  reducers: {
    toggleCandidate: (state, action) => {
      const id = action.payload;
      const index = state.selectedIds.indexOf(id);
      if (index >= 0) {
        // Remove from selection
        state.selectedIds.splice(index, 1);
      } else {
        // Add to selection
        state.selectedIds.push(id);
      }
    },
    setSelected: (state, action) => {
      state.selectedIds = action.payload;
    },
    clearSelection: (state) => {
      state.selectedIds = [];
    },
    setSending: (state, action) => {
      state.isSending = action.payload;
    },
    setSendProgress: (state, action) => {
      state.sendProgress = action.payload;
    }
  }
});

// Export actions
export const {
  toggleCandidate,
  setSelected,
  clearSelection,
  setSending,
  setSendProgress
} = emergencySelectionSlice.actions;

// Export selectors
export const selectSelectedIds = (state) => state.emergencySelection.selectedIds;
export const selectIsSending = (state) => state.emergencySelection.isSending;
export const selectSendProgress = (state) => state.emergencySelection.sendProgress;

// Export reducer
export default emergencySelectionSlice.reducer;
